import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SubscriptionsService } from 'src/app/subscriptions/subscriptions/services/subscriptions.service';
import { AuthService } from '../../msal/auth.service';
import { CommonService } from '../../services/common.service';
import { SearchUpdateConfirmationComponent } from '../search-update-confirmation/search-update-confirmation.component';

@Component({
  selector: 'app-team-website-sub-menu',
  templateUrl: './team-website-sub-menu.component.html',
  styleUrls: ['./team-website-sub-menu.component.scss']
})
export class TeamWebsiteSubMenuComponent implements OnInit {
  public url: string = '';
  submenu:boolean =false;
  @Output() closeSidebarHeader = new EventEmitter<any>();
  @ViewChild('changeMenuModal', {static: true})
  public changeMenuModal: SearchUpdateConfirmationComponent | any;
  public isMobileDevice = false;
  menu: string = '';
  constructor(
    private subscriptionsService : SubscriptionsService,
    private router: Router,
    private authService: AuthService,
    private commonService: CommonService
  ) {
    this.authService.subscribeToUrl((url: any) => {
      this.url = url;
    })
   }

  ngOnInit(): void {
    this.subscriptionsService.updateSelectedMenu('team-website-account');
    this.isMobileDevice = this.commonService.isMobileDevice();
    if(sessionStorage.getItem('currentUrl'))
      {
        this.url = sessionStorage.getItem('currentUrl') as string;  
        if(!this.url.includes('/team-website-account') 
          && !this.url.includes('/team-website-listings')
          && this.url !== '/portal/team-website')
          this.submenu = true;          
      }      
  }

     //return the selected menu
     get selectedMenu(): string {
      return this.subscriptionsService.selectedMenu;
    }

  /**
   * check if the menu is selected or not
   * @param menuItem 
   * @return boolean
   */

  public isMenuSelected(menuItem: string): boolean {
    return this.selectedMenu === menuItem;
  }


  /**
   * update the selected menu
   * @param menuItem 
   */
  public selectTeamMenu(menuItem: string): void {
    this.menu = menuItem;
    if (this.commonService.getFormUpdateStatus()) {
      this.changeMenuModal.showModal();
    } else {
      this.selectMenuConfirmation();
    }
  }

  /** select Menu confirmation popup event */
  selectMenuConfirmation() {
    this.commonService.setFormUpdateStatus(false);
    this.subscriptionsService.updateSelectedMenu(this.menu);
    this.closeSidebarHeader.emit(true);
    sessionStorage.setItem('activeUrl', '/portal/team-website/' + this.menu)
    this.router.navigate(['/portal/team-website/' + this.menu])
  }
  
  /** Team information submenu */
  toggleDisplay() {
    this.submenu = !this.submenu;
    if(!this.isMobileDevice && this.submenu && this.url.includes('/portal/team-website/team-website-')){
      this.router.navigate(['/portal/team-website/team-information']);
    }
  }

}
